import React from 'react';
import UsuarioNoValido from '../components/NotFound/usuarioNoValido';

const UsuariosNoValidos = () => {
    return (
       <UsuarioNoValido />
    );
};

export default UsuariosNoValidos;